<template>
    <div component="VideoRecorderCountDown" v-if="value">
        <div class="holder" :class="color">
            <div class="desc">{{ text }}</div>
            <div class="number">{{ number }}</div>
        </div>
    </div>
</template>

<script>
let countTimeout;

export default {
    name: 'VideoRecorderCountDown',
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        seconds: {
            required: true,
        },
        color: {
            type: String,
        },
        text: {
            type: String,
        },
    },

    data: () => ({
        number: null,
    }),

    methods: {
        startCountDown() {
            this.number = parseInt(this.seconds);
            const loop = () => {
                if (this.number == 1) {
                    clearTimeout(countTimeout);
                    this.$emit('input', false);
                    this.$emit('end');
                    return;
                }
                this.number--;
                countTimeout = setTimeout(loop, 1000);
            };
            countTimeout = setTimeout(loop, 1000);
        },
    },

    watch: {
        value(newVal) {
            clearTimeout(countTimeout);
            if (newVal) {
                this.startCountDown();
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='VideoRecorderCountDown'] {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .holder {
        background: @base !important;
        border-radius: 50%;
        width: 200px;
        height: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 15px;
        box-shadow: 0 0 80px 10px rgba(0, 0, 0, 0.8);

        &.red {
            background: @accent !important;
        }

        .number {
            font-size: 80px;
            font-weight: 700;
            line-height: 1;
        }
    }
}
</style>
